import { diseaseState } from './disease.state';
import { diseaseActions } from './disease.action';
import { diseaseMutations } from './disease.mutation';

export default {
  namespaced: true,
  state: diseaseState,
  getters: {},
  actions: diseaseActions,
  mutations: diseaseMutations,
};
